// extracted by mini-css-extract-plugin
export default {"ParticipantsList":"ParticipantsList-module-edc702a297a91861b431"};